// ------------------------------------
// Constants
// ------------------------------------
export const MESSAGE_BAR_SHOW_MESSAGE = 'MESSAGE_BAR_SHOW_MESSAGE';

// ------------------------------------
// Actions
// ------------------------------------
export function message (text = '') {
  return {
    type    : MESSAGE_BAR_SHOW_MESSAGE,
    payload : {
        rand: Math.random(),
        text: text
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
export function messageBarReducer (state = {text:''}, action) {
    return action.type === MESSAGE_BAR_SHOW_MESSAGE
        ? action.payload
        : state
}




// WEBPACK FOOTER //
// ./src/store/messageBar.js